import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
    InitializeRtlsPlayerParameters,
    RtlsPlayerOptions,
    SiteRtlsPlayer,
    UpdateRtlsPlayerParameters,
} from '@myrtls/api-interfaces';

export const getSitePlayerRequestAction = createAction(
    '[Player] Get Site Player Request',
);

export const startPoolingSitePlayerRequestAction = createAction(
    '[Player] Start Pooling Site Player Request',
    props<{ intervalTime: number }>(),
);

export const stopPoolingSitePlayerRequestAction = createAction(
    '[Player] Stop Pooling Site Player Request',
);

export const getSitePlayerSuccessAction = createAction(
    '[Player] Get Site Player Success',
    props<{ player: SiteRtlsPlayer }>(),
);

export const getSitePlayerFailureAction = createAction(
    '[Player] Get Site Player Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getPlayerOptionsRequestAction = createAction(
    '[Player] Get Player Options Request',
);

export const getPlayerOptionsSuccessAction = createAction(
    '[Player] Get Player Options Success',
    props<{ options: RtlsPlayerOptions }>(),
);

export const getPlayerOptionsFailureAction = createAction(
    '[Player] Get Player Options Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const initializeSitePlayerRequestAction = createAction(
    '[Player] Initialize Site Player Request',
    props<{ parameters: InitializeRtlsPlayerParameters }>(),
);

export const initializeSitePlayerSuccessAction = createAction(
    '[Player] Initialize Site Player Success',
    props<{ player: SiteRtlsPlayer }>(),
);

export const initializeSitePlayerFailureAction = createAction(
    '[Player] Initialize Site Player Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const updateSitePlayerRequestAction = createAction(
    '[Player] Update Site Player Request',
    props<{ parameters: UpdateRtlsPlayerParameters }>(),
);

export const updateSitePlayerSuccessAction = createAction(
    '[Player] Update Site Player Success',
    props<{ player: SiteRtlsPlayer }>(),
);

export const updateSitePlayerFailureAction = createAction(
    '[Player] Update Site Player Failure',
    props<{ error: HttpErrorResponse }>(),
);

